/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { SportPersonFootballIcon16Light } from './SportPersonFootballIcon16Light';
import { SportPersonFootballIcon16Regular } from './SportPersonFootballIcon16Regular';
import { SportPersonFootballIcon16Solid } from './SportPersonFootballIcon16Solid';
import { SportPersonFootballIcon20Light } from './SportPersonFootballIcon20Light';
import { SportPersonFootballIcon20Regular } from './SportPersonFootballIcon20Regular';
import { SportPersonFootballIcon20Solid } from './SportPersonFootballIcon20Solid';
import { SportPersonFootballIcon24Regular } from './SportPersonFootballIcon24Regular';
import { SportPersonFootballIcon24Solid } from './SportPersonFootballIcon24Solid';
import { SportPersonFootballIcon32Regular } from './SportPersonFootballIcon32Regular';
import { SportPersonFootballIcon64Regular } from './SportPersonFootballIcon64Regular';
var sizes = {
    16: {
        light: SportPersonFootballIcon16Light,
        regular: SportPersonFootballIcon16Regular,
        solid: SportPersonFootballIcon16Solid,
    },
    20: {
        light: SportPersonFootballIcon20Light,
        regular: SportPersonFootballIcon20Regular,
        solid: SportPersonFootballIcon20Solid,
    },
    24: {
        regular: SportPersonFootballIcon24Regular,
        solid: SportPersonFootballIcon24Solid,
    },
    32: {
        regular: SportPersonFootballIcon32Regular,
    },
    64: {
        regular: SportPersonFootballIcon64Regular,
    },
};
export var SportPersonFootballIcon = forwardRef('SportPersonFootballIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
